const angular = require('angular');
var app = angular.module('learn-controllers');

app.controller('overviewSettingsController', [
  'Application',
  function (Application) {
    var self = this;
    self.title = 'Settings'

    self.routeParameters = Application.navigation.getRouteParameters();
    const type = self.routeParameters.type;

    const getTitle = function(type) {
      switch(type) {
        case 'categories':
          return 'overview.settings.tabs_categories';
        case 'locations':
          return 'overview.settings.tabs_locations';
        case 'departments':
          return 'overview.settings.tabs_departments';
        case 'teams':
          return 'overview.settings.tabs_teams';
        case 'grades':
          return 'overview.settings.tabs_grades';
        case 'theme':
          return 'Theme';
        case 'groups':
          return 'reports.fields.groups';
        case 'skills':
          return 'overview.settings.tabs_skills';
        case 'integrations':
          return 'overview.settings.integrations';
        case 'profiles':
          return 'overview.settings.access_profiles';
        case 'seats':
          return 'overview.settings.user_licenses';
        case 'organization-levels':
        case 'org_levels':
        case 'levels':
          return 'overview.settings.tabs_org_levels';
        case 'transfer':
          return 'Transfer';
        case 'application-tokens':
        case 'api_applications':
          return 'overview.settings.api_application';
        default:
          return 'overview.settings.title_settings';
      }
    };

    self.title = getTitle(type);

  },
]);
